const mailMerge = {
  access: {
    title: "Serienbrief Datenquelle Ordner",
    hint: "Die Freigabe gilt für dieses Gerät und dieses Browserprofil. Welcher Ordner erwartet wird, legen die Systemeinstellungen fest.",
    descriptions: {
      unsupported:
        "Serienbrief-Funktionen sind in diesem Browser nicht verfügbar. Bitte SONeu in <bold>Chrome</bold> oder <bold>Microsoft Edge</bold> öffnen.",
      notConfigured:
        "Es ist noch kein Serienbrief-Ordner konfiguriert. Bitte wenden Sie sich an eine:n Supervisor:in.",
      notGranted:
        "Der Ordner ist an diesem Gerät noch nicht freigegeben – die Datenquellen für die Serienbriefe können noch nicht geschrieben werden.",
      permissionLost:
        "Der Zugriff auf <path>{{expected}}</path> ist nicht mehr erlaubt. Serienbriefe können erst nach dem Wiederherstellen geschrieben werden.",
      permissionDenied:
        "Der Browser blockiert den Zugriff auf <path>{{expected}}</path>. Erlauben Sie den Dateizugriff in den Browsereinstellungen für diese Seite und laden Sie SONeu danach neu.",
      loadFailed:
        "Der Status der Ordnerfreigabe konnte nicht ermittelt werden. Bitte laden Sie SONeu neu.",
      folderMismatch:
        "Der ausgewählte Ordner passt nicht zum erwarteten Ordner <path>{{expected}}</path>. Die Word-Vorlagen würden ihre Datenquelle nicht finden — bitte den Ordner erneut freigeben.",
    },
    actions: {
      grant: "Ordner freigeben",
      restore: "Zugriff wiederherstellen",
      manage: "Ordner verwalten",
      change: "Anderen Ordner wählen",
      reset: "Freigabe zurücksetzen",
    },
    manageDialog: {
      title: "Serienbrief Datenquelle Ordner ist freigegeben",
      folderLabel: "Ordner",
      statusLabel: "Freigabe",
      statusGranted: "Freigegeben",
    },
    unavailableDialog: {
      title: "Serienbrief nicht verfügbar",
    },
    deniedDialog: {
      title: "Zugriff blockiert",
      text: "Der Browser blockiert den Dateizugriff für SONeu, daher erscheint keine Abfrage mehr. Erlauben Sie den Zugriff in den Browsereinstellungen für diese Seite und laden Sie SONeu danach neu.",
    },
    folderDialog: {
      grantTitle: "Ordner einmalig freigeben",
      mismatchTitle: "Ausgewählter Ordner passt nicht",
      explanation:
        "Der Serienbrief funktioniert nur, wenn <bold>genau dieser Ordner</bold> freigegeben wird. Der Browser kann den Ordner nicht selbst öffnen — die Auswahl im nächsten Dialog muss manuell erfolgen.",
      selectedLabel: "Ausgewählt",
      targetLabel: "Diesen Ordner auswählen",
      copyPath: "Pfad kopieren",
      pathCopied: "Pfad wurde in die Zwischenablage kopiert.",
      copyFailed: "Der Pfad konnte nicht kopiert werden.",
      warning:
        "Wird ein anderer Ordner freigegeben, finden die Word-Vorlagen ihre Datenquelle nicht und der Serienbrief bleibt leer.",
      permissionHint:
        "Wählen Sie in der Abfrage des Browsers „Bei jedem Besuch erlauben“, damit die Freigabe erhalten bleibt.",
      confirm: "Ordner auswählen",
    },
    restoreDialog: {
      title: "Zugriff auf den Ordner ist beendet",
      text: "Die Freigabe für <path>{{expected}}</path> gilt nicht mehr. Sie wurde entweder nur für eine Sitzung erteilt („Nur diesmal erlauben“) und alle SONeu-Tabs wurden geschlossen, oder die Berechtigung wurde im Browser entzogen.",
      hint: "In der Browser-Rückfrage <bold>„Bei jedem Besuch erlauben“</bold> wählen. Mit „Nur diesmal erlauben“ endet der Zugriff, sobald alle SONeu-Tabs geschlossen werden.",
      confirm: "Zugriff wiederherstellen",
    },
    resetDialog: {
      title: "Freigabe zurücksetzen?",
      text: "Die Freigabe wird entfernt. Der Ordner muss erneut freigegeben werden, bevor Serienbriefe geschrieben werden können.",
      confirm: "Zurücksetzen",
    },
    errors: {
      notReady: "Der Serienbrief-Ordner ist nicht freigegeben.",
      permissionLost: "Der Zugriff auf den Ordner ist beendet. Bitte stellen Sie ihn wieder her.",
      fileLocked:
        "Die Datei konnte nicht geschrieben werden, weil sie in einem anderen Programm geöffnet ist. Bitte schließen Sie sie in Word und versuchen Sie es erneut.",
      writeFailed: "Die Datei konnte nicht geschrieben werden.",
      accessFailed: "Die Ordnerfreigabe konnte nicht geändert werden. Bitte versuchen Sie es erneut.",
    },
  },
};

export default mailMerge;
